import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import {
  IAccountStatsDto,
  ICreateAccountDto,
  IGenerateSubAccountDto,
  IUpdateAccountDto,
} from 'common/src/types/account.dtos';
import {
  IAccount,
  IAllocationTemplate,
  IPage,
} from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getAccounts = async (
  params: DataQueryParams = {},
): Promise<IPage<IAccount>> => {
  return await getRequest(API_BASE_PATHS.ACCOUNTS, formatQueryParams(params));
};

export const getAccount = async (id: string): Promise<IAccount> =>
  await getRequest(`${API_BASE_PATHS.ACCOUNTS}/${id}`);

export const addAccount = async (body: ICreateAccountDto): Promise<string> =>
  await postRequest(API_BASE_PATHS.ACCOUNTS, {}, body);

export const updateAccount = async (
  id: string,
  body: IUpdateAccountDto,
): Promise<void> =>
  await patchRequest(`${API_BASE_PATHS.ACCOUNTS}/${id}`, {}, body);

export const deleteAccount = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.ACCOUNTS}/${id}`, {});

export const getLastBill = async (
  accountId: string,
  params?: { excludeBillId?: string; maxStartDate?: string | Date },
) =>
  await getRequest(
    `${API_BASE_PATHS.ACCOUNTS}/${accountId}/last-bill`,
    params ?? {},
  );

export const getAccountStats = async (
  accountId: string,
): Promise<IAccountStatsDto> =>
  await getRequest(
    `${API_BASE_PATHS.ACCOUNTS}/${accountId}/bill-account-stats`,
  );

export const getActiveAllocationTemplate = async (
  accountId: string,
): Promise<IAllocationTemplate> =>
  await getRequest(
    `${API_BASE_PATHS.ACCOUNTS}/${accountId}/active-allocation-template`,
  );

export const generateSubAccount = async (
  masterAccountId: string,
  subAccountDto: IGenerateSubAccountDto,
): Promise<string> =>
  await postRequest(
    `${API_BASE_PATHS.ACCOUNTS}/${masterAccountId}/generate-sub-account`,
    {},
    subAccountDto,
  );
